import {
  flowDetailSchema,
  flowReportSchema,
  type FlowDetail,
  type FlowLevel,
  type FlowReport,
  type FlowSort,
  type ReportRange,
} from '@eombor/contracts';
import { apiClient } from '../../auth/model/auth.store.js';
import type { ApiClient } from '../../../shared/api/client.js';

/**
 * Tuzilma bo'ylab statistika — manba `subdivision/.../report.controller.ts`.
 *
 * Bitta endpoint, to'rtta daraja. `level` va `parentId` BERILMASA, server
 * doiradan kelib chiqib boshlang'ich darajani o'zi tanlaydi — shu tufayli
 * sahifa «men kimman» degan savolni hal qilmaydi.
 */
export interface FlowNode {
  level: FlowLevel;
  /** `null` — MTU darajasi, uning ustida ota yo'q. */
  parentId: string | null;
}

/**
 * Qidiruv, saralash va sahifa — hammasi SERVERDA.
 *
 * Mijozda qilib bo'lmaydi: bitta MTU da mingdan ortiq korxona bo'lishi
 * mumkin va ochiq sahifa ichida saralash «eng faol» o'rniga «shu
 * yigirmatasining eng faoli» ni ko'rsatardi.
 */
export interface FlowView {
  q: string;
  sort: FlowSort;
  page: number;
}

/**
 * Detal so'raladigan TUGUN — ro'yxatning otasi emas, satrning o'zi.
 *
 * `FlowNode` dan ataylab boshqa shakl: u «qaysi ro'yxatni ko'rsat»
 * degani, bu esa «qaysi tugun haqida gapir». Ikkovi bir turga
 * qo'shilsa, `parentId` bir joyda ota, boshqa joyda bola bo'lib
 * ishlatilardi.
 */
export interface FlowTarget {
  level: FlowLevel;
  id: string;
  /** Panel sarlavhasi so'rov kelgunicha ham turishi uchun. */
  name: string;
  /** Pastga yo'l bo'lsa, panelning ostida «ichiga kirish» chiqadi. */
  drillLevel: FlowLevel | null;
}

export interface FlowApi {
  /** `node === null` — serverning o'zi tanlasin. */
  report: (range: ReportRange, node: FlowNode | null, view: FlowView) => Promise<FlowReport>;
  detail: (range: ReportRange, target: FlowTarget) => Promise<FlowDetail>;
}

export const createFlowApi = (client: ApiClient): FlowApi => ({
  report: (range, node, view) => {
    const params = new URLSearchParams({
      from: range.from,
      to: range.to,
      sort: view.sort,
      page: String(view.page),
    });
    if (node !== null) {
      params.set('level', node.level);
      if (node.parentId !== null) params.set('parentId', node.parentId);
    }
    /* Bo'sh qidiruv UMUMAN yuborilmaydi — serverda `q=''` va `q` yo'qligi
       bir xil ma'noni anglatishi kerak, lekin buni ikki joyda ta'minlab
       yurgandan ko'ra bir joyda yubormaslik ishonchliroq. */
    if (view.q !== '') params.set('q', view.q);
    return client.apiFetch(`/reports/flow?${params.toString()}`, { schema: flowReportSchema });
  },

  detail: (range, target) => {
    const params = new URLSearchParams({
      from: range.from,
      to: range.to,
      level: target.level,
      id: target.id,
    });
    return client.apiFetch(`/reports/flow/detail?${params.toString()}`, {
      schema: flowDetailSchema,
    });
  },
});

export const flowApi = createFlowApi(apiClient);
